import { render, staticRenderFns } from "./IconIndentLeft.vue?vue&type=template&id=d49cbca6&"
import script from "./IconIndentLeft.vue?vue&type=script&lang=js&"
export * from "./IconIndentLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports